import { render, staticRenderFns } from "./retire-post.vue?vue&type=template&id=39aaed28&scoped=true&"
import script from "./retire-post.vue?vue&type=script&lang=js&"
export * from "./retire-post.vue?vue&type=script&lang=js&"
import style0 from "./retire-post.vue?vue&type=style&index=0&id=39aaed28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aaed28",
  null
  
)

export default component.exports